export default "__VITE_ASSET__1dedad2a__"